export { default } from './QrHeroView';



// WEBPACK FOOTER //
// ./src/components/views/QrHeroView/index.js